export const web3ModalProjectId = '4f86b342ae15dfd74b27903df52326e7';
export const NETWORKS = [
    {
      chainId: 17000,
      name: 'Ethereum',
      currency: 'ETH',
      explorerUrl: 'https://etherscan.io',
      rpcUrl: 'https://cloudflare-eth.com'
      }
];